import { Badge as ChakraBadge } from '@chakra-ui/react';
import { PolymorphicProps, StyleProps, SystemProps } from './primitives.types';

export interface BadgeProps extends
  SystemProps,
  PolymorphicProps,
  Omit<React.ComponentPropsWithoutRef<'span'>, keyof StyleProps> {
  variant?: string;
  colorScheme?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function Badge(props: BadgeProps) {
  return <ChakraBadge {...props} />;
}